import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const Reinvention = () => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="reinvention-section">
      <div className="container-tm grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="aspect-[4/5] overflow-hidden bg-sand rounded-3xl shadow-lift">
            <img
              src="/images/saint-malo-remparts.jpg"
              alt="Remparts et façades en granit de Saint-Malo intra-muros"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-gold text-white rounded-2xl p-6 max-w-[260px] shadow-lift hidden md:block">
            <p className="font-serif text-xl leading-tight">
              Une équipe locale, présente <span className="font-semibold">24h/24 · 7j/7</span>.
            </p>
            <p className="mt-2 text-[12px] font-sans text-white/85">
              Permanence de nuit incluse · messages voyageurs traités en continu
            </p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="overline">Notre approche</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Nous réinventons
            <span className="italic text-gold"> la conciergerie BNB</span>.
          </h2>
          <p className="mt-8 font-sans text-base md:text-lg text-ink/70 leading-relaxed max-w-2xl">
            Check-in autonome ou physique, réservation de dernière minute, mise en ligne multi-plateformes, optimisation du référencement de votre annonce, ajustement quotidien des prix et accompagnement local.
          </p>
          <p className="mt-5 font-sans text-base md:text-lg text-ink/70 leading-relaxed max-w-2xl">
            <span className="font-semibold text-ink">TERRE ET MER CONCIERGERIE</span> casse les codes de la conciergerie traditionnelle pour maximiser votre rentabilité, tout en préservant votre logement.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/services" className="btn-primary group" data-testid="reinvention-cta-services">
              Découvrir nos services
              <ArrowRight size={14} strokeWidth={2} className="ml-3 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link to="/contact" className="btn-ghost" data-testid="reinvention-cta-contact">
              Nous contacter
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reinvention;
